import {
    Paper, Tabs, Tab
} from '@mui/material';
import { useState, useContext} from 'react';
import UserContext from '../../context/user';
import popUpMessage from '../../config/popUpMsg.json';

const Profile = (props) => {
    const UserInfo = useContext(UserContext); 
    const [tabs, ] = useState(0);    
    const [popMsg] = useState(popUpMessage.noUserAccess)   
    const renderHTML = (html) => ({ __html: html });

    return (
        <section className={"container extra-margin-top-less"}>
            <>                              
                <Paper square className='mb-2'>
                <Tabs  TabIndicatorProps={{style: {background:'#CE2A1D'}}}
                        value={tabs}             
                        textColor="primary"
                        aria-label="disabled tabs example"                        
                    >
                        {<Tab className='_wg-dynamic-text' label={props.noDcrAccess?'Access Denied':'No Access'} />}
                        
                    </Tabs>
                </Paper>
                {
                    (UserInfo.countries === undefined ||
                        (UserInfo.countries !== undefined && UserInfo.countries.length === 0)) &&
                    tabs === 0 &&
                    <div className=' container alert alert-warning _wg-dynamic-text'>
                        {props.noCommercialAccess ? <div dangerouslySetInnerHTML={renderHTML(popMsg[0].noComAccess.description)}/> : <div dangerouslySetInnerHTML={renderHTML(popMsg[0].noAccess.description)} /> }
                </div>
                }     
                {
                    props.noDcrAccess&&!UserInfo.isUserApprover&&     
                    <div className=' container alert alert-warning _wg-dynamic-text'>
                    <div dangerouslySetInnerHTML={renderHTML(popMsg[0].noApprovalAccess.description)} />
                    </div>
                }
                
            </>
            

        </section >
    )
}
export default Profile;